import {
    CreditCardIcon,
    GlobeAltIcon,
    PhoneIcon,
    UserGroupIcon,
    EnvelopeIcon,
    VideoCameraIcon,
    ClipboardDocumentIcon,
    Bars3Icon,
    QrCodeIcon,
    MapIcon,
    MicrophoneIcon,
    BuildingOfficeIcon
  } from '@heroicons/vue/24/outline'

const platformFeatures = [
    {
        id: 'registrationandtickets',
        name: 'Registration & Tickets',
        description: 'Complete registration and ticketing solution, tailored for professional events.',        
        icon: CreditCardIcon,
        link: '/features/registrationandtickets'
    },
    {
        id: 'websitesbuilder',
        name: 'Website Builder',
        description: 'Easy to use website build, with even easier deployments. Fast and secure.',
        icon: GlobeAltIcon,
        link: '/features/websitesbuilder'
    },
    {
        id: 'eventapp',
        name: 'Event Apps',
        description: 'Web and native apps, designed for ease of use and engagement for all attendees.',
        icon: PhoneIcon,
        link: '/features/eventapp'
    },
    {
        id: 'audienceparticipation',
        name: 'Audience Participation',
        description: 'Engage attendees with interactive features, including Q&A, polls, and more.',
        icon: UserGroupIcon,
        link: '/features/audienceparticipation'
    },
    {
        id: 'emailsandcommunications',
        name: 'Emails & Communications',
        description: 'Build, queue and send targeted emails and push notifications. Quick and easy setup.',
        icon: EnvelopeIcon,
        link: '/features/emailsandcommunications'
    },
    {
        id: 'meetingsandnetworking',
        name: 'Meetings & Networking',
        description: 'Facilitate connections and meetings between your attendees and exhibitors.',
        icon: VideoCameraIcon,
        link: '/features/meetingsandnetworking'
    },
    {
        id: 'leadcapture',
        name: 'Lead Capture',
        description: 'Capture and manage leads efficiently. All from the event app, no extra logins.',
        icon: ClipboardDocumentIcon,
        link: '/features/leadcapture'
    },
    {
        id: 'attendancetracking',
        name: 'Attendance Tracking',
        description: 'Track and manage capacity in real time. Scan badges or attendees can self-scan.',
        icon: Bars3Icon,
        link: '/features/attendancetracking'
    },
    {
        id: 'badgesandkiosks',
        name: 'Badges & Kiosks',
        description: 'Print badges and manage check-ins. Self-service or staff-assisted, or hyrbid.',
        icon: QrCodeIcon,
        link: '/features/badgesandkiosks'
    },
    {
        id: 'interactivefloorplans',
        name: 'Interactive Floorplans',
        description: 'Navigate and explore event spaces. Simple or fully mapped.',
        icon: MapIcon,
        link: '/features/interactivefloorplans'
    },
    {
        id: 'companyportals',
        name: 'Company Portals',
        description: 'Features for exhibitors and sponsors to manage their presence at the event.',
        icon: BuildingOfficeIcon,
        link: '/features/companyportals'
    },
    {
        id: 'speakerportals',
        name: 'Speaker Portals',
        description: 'Dedicated speaker management to update sessions, materials, bios, Q&A and more.',
        icon: MicrophoneIcon,
        link: '/features/speakerportals',
        comingSoon: true
    }
]

const getFeaturesByIds = (ids) => {
    const features = []
    for (const id of ids) {
        const feature = platformFeatures.find(feature => feature.id === id)
        if (feature) {
            features.push(feature)
        }
    }
    return features;
}

export { platformFeatures, getFeaturesByIds }